import './page/ap-prices-check';
import deDE from './snippet/de-DE';
import enGB from './snippet/en-GB';

Shopware.Module.register('ap-prices', {
    // configuration here
    type: 'plugin',
    name: 'Alphaplan Connector Prices',
    title: 'ap-prices.general.titleTextModule',
    description: 'ap-prices.general.descriptionTextModule',
    icon: 'alphaplan-icon',
    color: '#ff3d58',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },
    routes: {
        check: {
            component: 'ap-prices-check',
            path: 'check'
        }
    },
    navigation: [{
        id: 'ap-connector',
        label: 'ap-prices.general.mainMenuItemGeneral',
        color: '#ff3d58',
        icon: 'alphaplan-icon',
        position: 100,
        parent: 'sw-catalogue',
    }, {
        id: 'ap-prices',
        label: 'ap-prices.general.titleTextModule',
        color: '#ff3d58',
        path: 'ap.prices.check',
        position: 100,
        parent: 'ap-connector'
    }]

});
